import Decemebr2022 from 'images/mydata/December-2020.jpeg';
import ASN from 'images/mydata/ASN.png';
import NKF from 'images/mydata/NKF.jpg';
import September2020 from 'images/mydata/September2020.png';
import September2021 from 'images/mydata/September2021.png';
import November2021 from 'images/mydata/November2021.png';
import March2020 from 'images/mydata/March2020.png';
import Annual2020 from 'images/mydata/Annual2020.png';
import Annual2021 from 'images/mydata/Annual2021.png';
import Annual2022 from 'images/mydata/Annual2022.png';
import October2023 from 'images/mydata/October2023.png';
import People from 'images/mydata/June 2022.png';
import July2024 from 'images/mydata/July2024.png';
import March2025 from 'images/mydata/March2025.png';
import June2021 from 'images/mydata/June-2021.jpeg';
import Stats from 'images/mydata/stats.png';
import Dec22 from 'images/mydata/december-2022.png';
import { getRandomIndex } from 'utils/random';

export const mockData = [
  {
    id          : getRandomIndex(),
    title       : 'March 2025 Registry Newsletter',
    description : 'The March 2025 Registry Newsletter focuses on genetic testing and healthcare access. Check it out!',
    image       : March2025,
    pdfLink     : '/assets/March2025.pdf',
    fit         : 'fill',
  },
  {
    id          : getRandomIndex(),
    title       : 'July 2024 Participant Newsletter',
    description : 'There\'s so much to learn about the ADPKD journey, and we appreciate you helping us do just that. We\'ve released the July Registry Newsletter where we discuss social determinants of health, priority research questions we hope to answer with Registry data, and the new module on Patient-Centered Insights on Treatment Adherence',
    image       : July2024,
    pdfLink     : '/assets/July2024Newsletter.pdf',
    fit         : 'fill',
  },
  {
    id    : getRandomIndex(),
    title : 'October 2023 Participant Newsletter',
    description :
      'Thank you to all our ADPKD Registry participants who\'ve stuck with us during the transition to the updated platform. We appreciate your dedication to research and the mission to end PKD',
    image   : October2023,
    pdfLink : '/assets/October2023Newsletter.pdf',
    fit     : 'fill',
  },
  {
    id    : getRandomIndex(),
    title : 'ADPKD Registry Annual Impact Report 2022',
    description :
      'The information that you provide in the ADPKD Registry directly impacts research. How? Check out the 2022 Annual Report where we share some of our data and talk about why it’s important.',
    image : Annual2022,
    pdfLink :
      'https://pkdcure.org/wp-content/uploads/ADPKD-Registry-Annual-Impact-Report-2022_final.pdf',
    fit : 'fill',
  },
  {
    id    : getRandomIndex(),
    title : 'December 2022 Participant Newsletter',
    description :
      'Thank you to all our ADPKD Registry participants that have joined us in 2022 and those that have stuck with us since the beginning.',
    image : Dec22,
    fit   : 'fill',
    pdfLink :
      'https://pkdcure.org/wp-content/uploads/4-ADPKD-Registry-Newsletter-dec2022-v5-1.pdf',
  },
  {
    id    : 1,
    title : 'Kidney 360',
    description :
      'Design and basic characteristics of a national patient-powered registry in ADPKD',
    image : Stats,
    pdfLink :
      'https://journals.lww.com/kidney360/Fulltext/2022/08000/Design_and_Basic_Characteristics_of_a_National.12.aspx',
  },
  {
    id    : 2,
    title : 'NKF SCM 2022',
    description :
      'PKDF attended the National Kidney Foundation’s clinician-facing meeting to talk about what pain looks like in ADPKD along various stages of disease.',
    image   : NKF,
    pdfLink : '/assets/NKF-registry.pdf',
    fit     : 'fill',
  },
  {
    id    : 3,
    title : '2020 Annual Report',
    description :
      'The information that you provide in the ADPKD Registry directly impacts research. How? Check out the 2020 Annual Report where we share some of our data and talk about why it’s important.',
    image   : Annual2020,
    pdfLink : '/assets/annual-report-2020.pdf',
  },
  {
    id    : 4,
    title : '2021 Annual Report',
    description :
      'The information that you provide in the ADPKD Registry directly impacts research. How? Check out the 2021 Annual Report where we share some of our data and talk about why it’s important.',
    image   : Annual2021,
    pdfLink : '/assets/annual-report-2021.pdf',
  },
  {
    id    : 5,
    title : 'ASN Kidney Week 2021',
    description :
      'PKDF presented a poster at the American Society of Nephrology’s 2021 Kidney Week, along with members of the Patient Registry Advisory Committee.',
    image   : ASN,
    pdfLink : '/assets/ASN-poster-2021.pdf',
  },
  {
    id    : 6,
    title : 'ASN Kidney Week 2020 poster',
    description :
      'PKDF presented a poster at the American Society of Nephrology’s 2020 Kidney Week, along with members of the Patient Registry Advisory Committee.',
    image   : ASN,
    pdfLink : '/assets/ASN-poster-2020.pdf',
  },
  {
    id    : 7,
    title : 'June 2021 Participant Newsletter',
    description :
      'Our program focuses on patient-centered research and putting ADPKD patients at the center of all we are learning about PKD. Thank you for trusting us and signing up to make this work possible.',
    image   : June2021,
    pdfLink : '/assets/newsletter-jun2021.pdf',
  },
  {
    id    : 8,
    title : 'September 2021 Participant Newsletter',
    description :
      'Your contributions can make a real difference in research about ADPKD: its symptoms, its progression, its treatment, and its impact on quality of life. Thank you!',
    image   : September2021,
    pdfLink : '/assets/newsletter-sept2021.pdf',
  },
  {
    id    : 9,
    title : 'November 2021 Participant Newsletter',
    description :
      'Without participants like you, we wouldn’t have new insights into the patient journey or what pain looks like in ADPKD. During this month of thanks, we’re so grateful for you. Thank you for being a part of this program with us!',
    image   : November2021,
    pdfLink : '/assets/newsletter-nov2021.pdf',
  },
  {
    id    : 10,
    title : 'June 2022 Participant Newsletter',
    description :
      'Thank you for helping to advance the understanding of ADPKD. Your commitment to the Registry doesn’t go unnoticed! Your data matters and we are excited to share with you what we are learning.',
    image   : People,
    pdfLink : '/assets/newsletter-jun2022.pdf',
  },
  {
    id    : 11,
    title : 'December 2020 Participant Newsletter',
    description :
      'When we count our blessings this holiday season, we count you twice. Thank you for supporting the ADPKD Registry by participating and making this work possible.',
    image   : Decemebr2022,
    pdfLink : '/assets/newsletter-dec2020.pdf',
  },
  {
    id    : 12,
    title : 'September 2020 Participant Newsletter',
    description :
      'We’re so excited to have so many join us! There is power in numbers. You’re helping us to advance PKD research.',
    image   : September2020,
    pdfLink : '/assets/newsletter-sept2020.pdf',
  },
  {
    id    : 13,
    title : 'March 2020 Participant Newsletter',
    description :
      'We’re so excited to have so many join us! There is power in numbers. You’re helping us to advance PKD research.',
    image   : March2020,
    pdfLink : '/assets/newsletter-mar2020.pdf',
  },
];
